import * as React from "react";
const SvgDownCaret = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L5 7L9 1", stroke: "#313131" }));
export default SvgDownCaret;
